$(function() {
    $('.dropdown-select2').select2()
    $('.unit-select2').select2({
        ajax: {
            url: '/ajax/dropdown-units',
            dataType: "json",
            type: "GET",
            data: function (params) {
                return {
                    search: params.term
                }
            },
            processResults: function (data, page) {
                return {
                    results: data
                };
            }
        }
    })
})
